import { type INotification } from '../../types/common/INotification';
import { StorageService } from '../../services';
import { produce } from 'immer';

const NOTIFICATION_KEY = 'notifications';

const NotificationService = {
    getNotifications,
    addNotification,
    removeNotification,
};

function getNotifications(): INotification[] {
    const notifications = StorageService.getSession(
        NOTIFICATION_KEY,
        '[]',
    ) as string;
    return JSON.parse(notifications);
}

function addNotification(notification: INotification) {
    const notifications = getNotifications();
    notifications.push(notification);
    StorageService.setSession(NOTIFICATION_KEY, JSON.stringify(notifications));
}

function removeNotification(timestamp: number) {
    const notifications = getNotifications();
    const index = notifications.findIndex(
        (notification: INotification) => notification.timestamp === timestamp,
    );
    if (index >= 0) {
        const newNotifications = produce(notifications, (draft) => {
            draft.splice(index, 1);
        });
        StorageService.setSession(
            NOTIFICATION_KEY,
            JSON.stringify(newNotifications),
        );
    }
}

export default NotificationService;
